import useAuth from '../hooks/useAuth';
import './ExploreContainer.css';


interface ContainerProps {
  name: string;
}

const ExploreContainer: React.FC<ContainerProps> = ({ name }) => {
  const {token} = useAuth();

  const url = name === "acp" ? "http://awagentdashboard.local:3001/enrollCustomerACP?jwt="+token 
  : name === "prepaid" ? "http://awagentdashboard.local:3001/prepaidToLifeline?jwt="+token
  : name === "ims" ? "http://awagentdashboard.local:3001/ims?jwt="+token 
  : name === "account" ? "http://awagentdashboard.local:3001/my-account?jwt="+token 
  : name === "dashboard" ? "http://entouch-dashboard.myagentdashboard.local:2000/dashboard?token="+token
  : ""; 

  return (
    <div className="container">
      <iframe src={url} style={{width:'100%', height: '100%', border: 'none'}} scrolling="yes"></iframe>
    </div>
  );
};

export default ExploreContainer;
